import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { PERMISSION_HO_TEAM_ID } from 'src/app/handover-constants';
import { Handover } from 'src/app/interfaces/handover';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-home-content-inbox-team',
  templateUrl: './home-content-inbox-team.component.html',
  styleUrls: ['./home-content-inbox-team.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HomeContentInboxTeamComponent implements OnInit {
  @Input() handoversInboxTeam: Handover[] | undefined;
  @Input() totalHandoversInboxTeam: number | undefined;
  @Input() searchInboxTeam: string | undefined;
  @Output() reloadTeam = new EventEmitter<boolean>();
  @Output() eventShowInboxPersonal = new EventEmitter<boolean>();
  @Output() handoversInboxTeamWithFilter = new EventEmitter<string>();

  textSearch = '';
  constructor() {
    // Agrego esta linea para que Husky deje hacer commit y push.
  }

  ngOnInit(): void {
    // Agrego esta linea para que Husky deje hacer commit y push.
    this.textSearch = this.searchInboxTeam ? this.searchInboxTeam : '';
  }

  eventReload(reload: boolean) {
    this.reloadTeam.emit(true);
  }
  showInboxPersonal() {
    this.eventShowInboxPersonal.emit(true);
  }

  getHandoversHomeInboxTeamWithFilter(searchText: string): void {
    this.textSearch = searchText;
    this.handoversInboxTeamWithFilter.emit(searchText);
  }
}
